import { render, staticRenderFns } from "./TdxTickerLogo.vue?vue&type=template&id=6bb807d8&scoped=true&"
import script from "./TdxTickerLogo.vue?vue&type=script&lang=js&"
export * from "./TdxTickerLogo.vue?vue&type=script&lang=js&"
import style0 from "./TdxTickerLogo.vue?vue&type=style&index=0&id=6bb807d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb807d8",
  null
  
)

export default component.exports